/** Should be in sync with org_user.py */
export enum OrgRole {
  ADMIN = "admin",
  RECORDING_AGENT = "recording_agent",
  OTHER = "other",
  NONE = "none",
}

/** Should be in sync with custom_auth.User.Role */
export enum UserRole {
  SUPER_ADMIN = "super_admin",
  GLOBAL_ADMIN = "global_admin",
  RECORDING_AGENT = "recording_agent",
}

/** Should be in sync with course_user.py */
export enum CourseRole {
  COURSE_ADMIN = "course_admin",
}

/** Should be in sync with section_user.py */
export enum SectionRole {
  INSTRUCTOR = "instructor",
  STUDENT = "student",
  RECORDING_AGENT = "recording_agent",
  SECTION_ASSISTANT = "section_assistant",
}

/** Highest-privilege role across org, course, and section  */
export enum MaxRole {
  SUPER_ADMIN = "super_admin",
  GLOBAL_ADMIN = "global_admin",
  ORG_ADMIN = "org_admin",
  COURSE_ADMIN = "course_admin",
  INSTRUCTOR = "instructor",
  SECTION_ASSISTANT = "section_assistant",
  STUDENT = "student",
}

export type CoreUserRole = SectionRole.INSTRUCTOR | SectionRole.STUDENT;
